<template>
  <section class="instagram-grid mt-0" aria-labelledby="instagram-grid-title">
    <div class="container px-2 px-lg-4">
      <div
        class="instagram-grid__head"
        data-aos="ig-head-reveal"
        data-aos-delay="80"
        data-aos-duration="560"
        data-aos-easing="ease-out-cubic"
      >
        <div>
          <p class="instagram-grid__eyebrow">Comunidad FixGlass</p>
          <h3 id="instagram-grid-title" class="instagram-grid__title">Seguinos en Instagram</h3>
          <p class="instagram-grid__subtitle">
            Tips, reparaciones y novedades reales desde el local.
          </p>
        </div>
        <a
          class="instagram-grid__cta"
          href="https://www.instagram.com/fixglass"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i class="fab fa-instagram" aria-hidden="true"></i>
          Ver perfil
        </a>
      </div>

      <div
        class="instagram-grid__wrap"
        :class="{ 'is-hovering': cursorVisible }"
        @mousemove="handleMouseMove"
        @mouseleave="hideCursor"
      >
        <div class="instagram-grid__cursor" :style="cursorStyle" aria-hidden="true">
          <i class="fab fa-instagram"></i>
          <span>Ver Instagram</span>
        </div>
        <div class="instagram-grid__track">
          <a
            v-for="(item, index) in loopItems"
            :key="`${item.id}-${index}`"
            class="instagram-grid__item"
            :class="{ 'is-duplicate': index >= items.length }"
            :href="item.href"
            data-aos="ig-card-reveal"
            :data-aos-delay="String(igCardDelay(index))"
            data-aos-duration="520"
            data-aos-easing="ease-out-cubic"
            target="_blank"
            rel="noopener noreferrer"
            @mouseenter="showCursor"
            @mouseleave="hideCursor"
          >
            <img
              :src="item.image"
              :alt="item.alt"
              loading="lazy"
              decoding="async"
            />
            <div class="instagram-grid__overlay">
              <span class="instagram-grid__label">{{ item.label }}</span>
            </div>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, computed } from 'vue'

import accesorios from '@/assets/images/posts-de-instagram/accesorios.png'
import tecnicoBarato from '@/assets/images/posts-de-instagram/tecnico_barato.png'
import reparacionDiagnostico from '@/assets/images/posts-de-instagram/reparacion_diagnostico.png'
import mitosVerdades from '@/assets/images/posts-de-instagram/mitos_y_verdades_reacondicionados.png'
import reparacionPantalla from '@/assets/images/posts-de-instagram/reparaciones.png'
import juli1 from '@/assets/images/posts-de-instagram/juli-1.png'
import juli2 from '@/assets/images/posts-de-instagram/juli-2.png'

const cursorVisible = ref(false)
const cursorX = ref(0)
const cursorY = ref(0)

const items = [
  {
    id: 'accesorios',
    label: 'Accesorios',
    href: 'https://www.instagram.com/p/DMLtlWXtj1m/',
    image: accesorios,
    alt: 'Post de Instagram sobre accesorios',
  },
  {
    id: 'reparacion-pantalla',
    label: 'Reparacion de pantalla',
    href: 'https://www.instagram.com/p/DLnqUnQui_U/',
    image: reparacionPantalla,
    alt: 'Post de Instagram sobre reparacion de pantalla',
  },
  {
    id: 'tecnico-barato',
    label: 'Tecnico barato',
    href: 'https://www.instagram.com/p/DNg5dNMhP-a/',
    image: tecnicoBarato,
    alt: 'Post de Instagram sobre tecnico barato',
  },
  {
    id: 'juli-2',
    href: 'https://www.instagram.com/fixglassmerlo',
    image: juli2,
    alt: 'Post de Instagram en el local',
  },
  {
    id: 'reparacion-diagnostico',
    label: 'Reparacion y diagnostico',
    href: 'https://www.instagram.com/p/DLs0i2LubLg/',
    image: reparacionDiagnostico,
    alt: 'Post de Instagram sobre reparacion y diagnostico',
  },
  {
    id: 'mitos-verdades',
    label: 'Mitos y verdades',
    href: 'https://www.instagram.com/p/DNBySNWBsrX/',
    image: mitosVerdades,
    alt: 'Post de Instagram sobre mitos y verdades',
  },
  {
    id: 'juli-1',
    href: 'https://www.instagram.com/fixglassmerlo',
    image: juli1,
    alt: 'Post de Instagram en el local',
  },
  
]

const loopItems = computed(() => [...items, ...items])

const igCardDelay = (index) => 90 + (index % items.length) * 45

const cursorStyle = computed(() => ({
  left: `${cursorX.value}px`,
  top: `${cursorY.value}px`,
  opacity: cursorVisible.value ? 1 : 0,
}))

function showCursor() {
  cursorVisible.value = true
}

function hideCursor() {
  cursorVisible.value = false
}

function handleMouseMove(event) {
  const rect = event.currentTarget.getBoundingClientRect()
  cursorX.value = event.clientX - rect.left
  cursorY.value = event.clientY - rect.top
}
</script>

<style scoped>
.instagram-grid {
  position: relative;
  margin-top: clamp(2.5rem, 6vw, 3.5rem);
  padding: clamp(2.5rem, 6vw, 3.5rem) 0;
  color: #111111;
  --ig-gray: rgba(17, 17, 17, 0.65);
  border-radius: clamp(1rem, 3vw, 2rem);
  overflow: hidden;
}

.instagram-grid :deep(.container) {
  position: relative;
  z-index: 2;
}

.instagram-grid__head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1.5rem;
  flex-wrap: wrap;
  margin-bottom: clamp(1.5rem, 3vw, 2.5rem);
}

[data-aos="ig-head-reveal"],
[data-aos="ig-card-reveal"] {
  opacity: 0;
  transform: translate3d(0, 16px, 0);
  transition-property: opacity, transform;
}

[data-aos="ig-card-reveal"] {
  transform: translate3d(0, 14px, 0) scale(0.985);
}

[data-aos="ig-head-reveal"].aos-animate,
[data-aos="ig-card-reveal"].aos-animate {
  opacity: 1;
  transform: translate3d(0, 0, 0) scale(1);
}

/* en mobile centrado el contenido incluyendo el boton */
@media (max-width: 575.98px) {
  .instagram-grid__head {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

}

.instagram-grid__eyebrow {
  text-transform: uppercase;
  letter-spacing: 0.2em;
  font-weight: 700;
  font-size: 0.7rem;
  color: var(--ig-gray);
  margin: 0 0 0.5rem;
}

.instagram-grid__title {
  margin: 0 0 0.5rem;
  font-family: 'General-Sans', sans-serif;
  font-size: clamp(1.8rem, 3.6vw, 2.6rem);
  font-weight: 800;
  letter-spacing: 0;
  text-transform: none;
}

.instagram-grid__subtitle {
  margin: 0;
  font-size: 1rem;
  line-height: 1.55;
  color: var(--ig-gray);
  max-width: 520px;
}

.instagram-grid__cta {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.75rem 1.25rem;
  border-radius: 999px;
  background: #111111;
  color: #ffffff;
  text-decoration: none;
  font-weight: 700;
  letter-spacing: 0.02em;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.instagram-grid__cta:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.18);
}

.instagram-grid__wrap {
  position: relative;
  overflow: hidden;
}

.instagram-grid__wrap::before,
.instagram-grid__wrap::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  width: clamp(36px, 8vw, 140px);
  pointer-events: none;
  z-index: 1;
}

.instagram-grid__wrap::before {
  left: 0;
  background: linear-gradient(90deg, #ffffff 0%, rgba(255, 255, 255, 0) 70%);
}

.instagram-grid__wrap::after {
  right: 0;
  background: linear-gradient(270deg, #ffffff 0%, rgba(255, 255, 255, 0) 70%);
}

.instagram-grid__track {
  --carousel-gap: clamp(0.75rem, 2vw, 1.25rem);
  display: flex;
  gap: var(--carousel-gap);
  width: max-content;
  animation: instagram-scroll-left 34s linear infinite;
}

.instagram-grid__wrap.is-hovering {
  cursor: none;
}

.instagram-grid__item {
  position: relative;
  flex: 0 0 auto;
  width: clamp(220px, 20vw, 270px);
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.08);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  cursor: none;
}

.instagram-grid__item * {
  cursor: none;
}

.instagram-grid__item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  aspect-ratio: 1 / 1;
  background: #f7f7f7;
}

.instagram-grid__item:hover {
  transform: translateY(-6px) scale(1.01);
  box-shadow: 0 26px 60px rgba(0, 0, 0, 0.16);
}

.instagram-grid__overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(160deg, rgba(0, 0, 0, 0.05) 10%, rgba(0, 0, 0, 0.55) 100%);
  opacity: 0;
  display: flex;
  align-items: flex-end;
  padding: 1rem;
  transition: opacity 0.2s ease;
}

.instagram-grid__item:hover .instagram-grid__overlay {
  opacity: 1;
}

.instagram-grid__label {
  color: #ffffff;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.instagram-grid__cursor {
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-50%, -50%);
  z-index: 2;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.9rem;
  border-radius: 999px;
  background: rgba(17, 17, 17, 0.92);
  color: #ffffff;
  font-weight: 700;
  font-size: 0.85rem;
  letter-spacing: 0.02em;
  pointer-events: none;
  transition: opacity 0.12s ease;
  mix-blend-mode: normal;
}

@keyframes instagram-scroll-left {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(-50% - (var(--carousel-gap) / 2)));
  }
}

@media (max-width: 575.98px) {
  .instagram-grid__item {
    flex: 0 0 auto;
    width: clamp(240px, 76vw, 320px);
  }

  .instagram-grid__cursor {
    display: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .instagram-grid__track {
    animation: none;
    transform: none;
  }
}
</style>
